import { GeneralRoundInfo } from './GeneralRoundInfo';

export default GeneralRoundInfo;
